import { Button } from '@repo/shared-client/components/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { env } from '@web/src/lib/env.client'
import i18n from '@web/src/lib/intl/i18n'
import { useTranslation } from '@web/src/lib/intl/react'
import { HeartIcon } from 'lucide-react'

export const Route = createFileRoute('/(auth)/(main-layout)/supporter/thank-you')({
  component: SupporterThankYouPage,
  head: () => {
    const t = i18n.t.bind(i18n)
    return {
      meta: [
        { title: `${t('Thank You for Your Support')} | ${env.VITE_APP_NAME}` },
        { name: 'description', content: t('Thank you for supporting Spicy Friends') },
        { name: 'robots', content: 'noindex,nofollow' },
      ],
    }
  },
})

function SupporterThankYouPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="mx-auto w-full max-w-xl px-4 py-6 md:py-10">
      <div className="flex flex-col items-center gap-6 pt-4 pb-8 text-center lg:pt-12">
        <HeartIcon aria-hidden className="size-20 text-red-400" strokeWidth={1.5} />
        <h1 className="font-semibold text-3xl text-foreground md:text-4xl">{t('Thank You for Your Support!')}</h1>
        <p className="text-lg text-muted-foreground">
          {t(
            'We truly appreciate your commitment to Spicy Friends. Your support helps us keep this community safe, open, and growing.'
          )}
        </p>
        <p className="text-base text-muted-foreground">
          {t(
            "Please allow a couple of business days for us to process your payment and activate your supporter benefits. You'll receive a confirmation once everything is set up."
          )}
        </p>
        <div className="flex flex-col gap-3 pt-4">
          <Button onClick={() => navigate({ to: '/' })}>{t('Return to Home')}</Button>
        </div>
      </div>
    </div>
  )
}
